module.exports = "../dist/img/img_1-22.1cd8.jpg";